<div mat-dialog-content id="data-to-print">
    <div id="recovery-codes-container">
        <h2 class="verify-title">Recovery codes</h2>

        <h4 *ngIf="isPrinting">{{customer}} multi-factor authentication account recovery codes.</h4>

        <h3 *ngIf="!isPrinting">Recovery codes are used to access your account in case you lose access to
            your device and cannot receive multi-factor authentication codes.
            Each code can be used only once.
        </h3>

        <p class="notification warning-msg">
            <mat-icon>warning</mat-icon> Put these in a safe spot. If you lose your device and don’t have the recovery codes you will lose access to your account.
        </p>

        <mat-list role="list">
            <mat-list-item *ngFor="let recoveryCode of recoveryCodes" role="listitem">
                {{recoveryCode}}
            </mat-list-item>
        </mat-list>

        <div *ngIf="!isPrinting" class="mt-12 mb-24">Download, print, or copy your recovery codes before continuing two-factor authentication setup below.</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between start" *ngIf="!isPrinting">
        <button mat-stroked-button color="primary"
                class="submit-button"
                aria-label="Download Recovery codes"
                title="Download Recovery codes"
                color=""
                (click)="onDownload()"
        >
            <mat-icon>file_download</mat-icon>Download
        </button>

        <button mat-stroked-button color="primary"
                class="submit-button"
                aria-label="Print Recovery codes"
                title="Print Recovery codes"
                color=""
                (click)="onPrint()"
        >
            <mat-icon>print</mat-icon>Print
        </button>

        <button mat-stroked-button color="primary"
                class="submit-button"
                aria-label="Copy Recovery codes"
                title="Copy Recovery codes"
                color=""
                ngxClipboard
                [cbContent]="recoveryCodes"
                (cbOnSuccess)="onCopyToClipboard()"
        >
            <mat-icon>content_copy</mat-icon>
            Copy
        </button>
    </div>

</div>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" *ngIf="!isPrinting">
    <div></div>

    <button mat-raised-button
            class="mt-24"
            color="primary"
            [disabled]="!recoveryCodesWereSavedByUser && recoveryCodesHaveToBeSaved"
            (click)="onCloseRecoveryCodes()"
    >
        Close
    </button>
</mat-dialog-actions>
